import { exportDB, importInto } from "dexie-export-import";
import Dexie from "dexie";

class BaseStorage {
    constructor(storage) {
        this.storage = storage;
    }

    async exportRawBlob() {
        const db = await new Dexie(this.storage.name).open();
        return exportDB(db);
    }

    async exportBlob() {
        return exportDB(this.storage);
    }

    async importBlob(blob) {
        return importInto(this.storage, blob);
    }

    async clear() {
        return this.storage.delete().then(() => this.storage.open());
    }
}

export default BaseStorage;
